import request from "@/config/utils/request";
import { addUrlPerFix } from "@/basa/utils";

export function getAuthMenu(data) {
  return request({
    url: "apis/sp/app/getAuthMenu",
    method: "post",
    data
  });
}

export function getDetail(data) {
  return request({
    url: addUrlPerFix(process.env.VUE_APP_BASEP_URL) + "/apis/basap/getDetail",
    method: "post",
    data
  });
}

export function getLogin(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/users/signup/getLogin",
    method: "post",
    data
  });
}

export function getAppToken(data) {
  return request({
    url: "/apis/sp/oauth2/codeRedirect",
    method: "post",
    data
  });
}

export function login(data) {
  return request({
    url: "/apis/pp/users/signup/jjt/login",
    method: "post",
    data
  });
}
export function checkInnerUnitService(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_LSCP_URL) +
      "/apis/lscp/inquiry/users/signup/checkInnerUnitService",
    method: "post",
    data
  });
}
// export function getUser(data) {
//   return request({
//     url: "/apis/pp/users/signup/jjt/user",
//     method: "post",
//     data
//   });
// }

export function getUserInfo(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) + "/apis/basap/getUserInfo",
    method: "post",
    data
  });
}

export function getUserInfoA(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/getUserInfo?type=1",
    method: "post",
    data
  });
}
